import React from 'react';
import Toggle from '..';
import type { UncontrolledToggle } from '../shared/types';

/**
 * ToggleButton - Implements state internally
 */
export default function UncontrolledToggleButton(props: UncontrolledToggle) {
    const { initialValue, onChange, ...restProps } = props;

    return (
        <Toggle initialValue={initialValue} onChange={onChange}>
            <Toggle.Button {...restProps} />
        </Toggle>
    );
}
